/* HDC – Herbst-Countdown, Liefertage und Saisonphase (Rollrasen Herbst 2026) */
(function () {
  if (window.hdcHerbstCountdown) return;
  window.hdcHerbstCountdown = true;

  var WEEKDAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var LEAD_DAYS = 2;              // Order Delivery Date: 2 volle Tage Vorlauf
  var DELIVERY_WEEKDAYS = [2, 3, 4, 5]; // Di–Fr

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function setPart(root, key, value) {
    root.querySelectorAll('[data-cd="' + key + '"]').forEach(function (el) {
      if (el.textContent !== String(value)) el.textContent = value;
    });
  }

  function hideExpired(el) {
    var wrap = el.closest('[data-hdc-expire]') || el;
    wrap.hidden = true;
  }

  function tickCountdowns() {
    var now = Date.now();
    document.querySelectorAll('[data-hdc-deadline]').forEach(function (el) {
      var diff = new Date(el.getAttribute('data-hdc-deadline')).getTime() - now;
      if (!(diff > 0)) { hideExpired(el); return; }
      var s = Math.floor(diff / 1000);
      setPart(el, 'd', Math.floor(s / 86400));
      setPart(el, 'h', pad(Math.floor((s % 86400) / 3600)));
      setPart(el, 'm', pad(Math.floor((s % 3600) / 60)));
      setPart(el, 's', pad(s % 60));
      el.classList.add('is-ready');
    });
  }

  function renderDeliveryDays() {
    document.querySelectorAll('[data-hdc-liefertage]').forEach(function (el) {
      var endParts = el.getAttribute('data-hdc-liefertage').split('-');
      var end = new Date(+endParts[0], +endParts[1] - 1, +endParts[2]);
      var today = new Date();
      var day = new Date(today.getFullYear(), today.getMonth(), today.getDate() + LEAD_DAYS);
      var first = null, count = 0;
      for (; day <= end; day.setDate(day.getDate() + 1)) {
        if (DELIVERY_WEEKDAYS.indexOf(day.getDay()) > -1) {
          count++;
          if (!first) first = new Date(day);
        }
      }
      if (!count) { hideExpired(el); return; }
      setPart(el, 'count', count);
      setPart(el, 'first', first ? WEEKDAYS[first.getDay()] + ', ' + pad(first.getDate()) + '.' + pad(first.getMonth() + 1) + '.' : '');
      el.hidden = false;
    });
  }

  function markSeasonPhase() {
    document.querySelectorAll('[data-hdc-season]').forEach(function (root) {
      var today = new Date();
      var md = (today.getMonth() + 1) * 100 + today.getDate();
      var phases = root.querySelectorAll('[data-from][data-to]');
      phases.forEach(function (p) {
        var from = +p.getAttribute('data-from'), to = +p.getAttribute('data-to');
        var active = from <= to ? (md >= from && md <= to) : (md >= from || md <= to);
        p.classList.toggle('is-now', active);
      });
    });
  }

  function init() {
    tickCountdowns();
    renderDeliveryDays();
    markSeasonPhase();
    setInterval(tickCountdowns, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { tickCountdowns(); renderDeliveryDays(); markSeasonPhase(); });
})();
